import $ from 'jquery';
import {isNil} from 'ramda';
import {messageHandler} from './sinclair.uiTools';
import {jQueryFetchJsonV1} from '@sinclair-digital/v2-content-service/lib/fetch';

//Set jQuery ajax global settings
$.ajaxSetup({
    cache: false, //cache bust all ajax requests
});

export const getPostJSONOpts = (opts = {}) =>
    Object.assign(
        {
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json',
        },
        opts,
    );

// make an authenticated ajax request to V1
export const ajaxRequest = (options = {}) => jQueryFetchJsonV1($)(options);

export const pAjax = opts =>
    new Promise((res, rej) =>
        ajaxRequest(opts)
            .then(res)
            .fail(rej),
    );

function isValid(httpVerb) {
    const types = ['GET', 'HEAD', 'POST', 'PUT', 'PATCH', 'DELETE'],
        verb = typeof httpVerb === 'string' ? httpVerb.toUpperCase() : '';

    return types.includes(verb);
}

export function getFetch(opts) {
    opts = $.isPlainObject(opts) ? opts : {};

    const obj = {
        type: opts.type && isValid(opts.type) ? opts.type : 'GET',
        beforeSend() {
            if (typeof opts.before === 'function') {
                opts.before(opts);
            } else if (opts.mainLoader !== false) {
                beforeMainLoader();
            }
        },
        complete(data, response) {
            if (typeof opts.complete === 'function') {
                opts.complete(data, response, opts);
            } else if (opts.mainLoader !== false) {
                completeMainLoader();
            }
        },
        success(data, response) {
            if (typeof opts.success === 'function') {
                opts.success(data, response, opts);
            }

            if (typeof opts.successMessage === 'string') {
                messageHandler('success', opts.successMessage);
            }
        },
        error(data, response) {
            if (typeof opts.errorMessage === 'string') {
                messageHandler('error', opts.errorMessage);
            }

            if (typeof opts.error === 'function') {
                opts.error(data, response, opts);
            } else {
                errorHandler(data, response);
            }
        },
        failure(data, response) {
            if (typeof opts.errorMessage === 'string') {
                messageHandler('error', opts.errorMessage);
            }

            errorHandler(data, response);
        },
    };

    if (opts.url) {
        obj.url = opts.url;
    }

    return obj;
}

export function getModelCallbacks(opts) {
    opts = typeof opts === 'object' ? opts : {};
    const options = {
        catch: false,
        patch: !!opts.patch,
        partialUpdate: !!opts.partialUpdate,
        success(model, response, data) {
            if (typeof opts.successMessage === 'string') {
                messageHandler('success', opts.successMessage);
            }

            if (typeof opts.success === 'function') {
                opts.success(model, response, data, opts);
            }
        },
        error(model, response) {
            if (typeof opts.errorMessage === 'string') {
                messageHandler('error', opts.errorMessage);
            }

            if (typeof opts.error === 'function') {
                opts.error(model, response, opts);
            }

            errorHandler(model, response);
        },
        failure(data, response) {
            if (typeof opts.errorMessage === 'string') {
                messageHandler('error', opts.errorMessage);
            }

            if (typeof opts.failure === 'function') {
                opts.failure(data, response, opts);
            }
            errorHandler(data, response);
        },
        beforeSend() {
            if (opts && typeof opts.before === 'function') {
                opts.before(opts);
            } else {
                if (opts && opts.mainLoader) {
                    beforeMainLoader();
                }
            }
        },
        complete(data, response) {
            if (opts && typeof opts.complete === 'function') {
                opts.complete(data, response, opts);
            } else {
                if (opts && opts.mainLoader) {
                    completeMainLoader();
                }
            }
        },
    };

    if (opts && opts.url) {
        options.url = opts.url;
    }

    return options;
}

export function getModelCallbacksMainLoader(opts) {
    opts = typeof opts === 'object' ? opts : {};

    const options = {
        patch: !!opts.patch,
        success(model, response, data) {
            if (typeof opts.success === 'function') {
                opts.success(model, response, data, opts);
            }
        },
        error(model, response) {
            completeMainLoader();
            errorHandler(model, response);
        },
        failure(data, response) {
            completeMainLoader();
            errorHandler(data, response);
        },
        beforeSend() {
            if (opts && typeof opts.before === 'function') {
                opts.before(opts);
            } else {
                beforeMainLoader();
            }
        },
        complete(data, response) {
            if (opts && typeof opts.complete === 'function') {
                opts.complete(data, response, opts);
            } else {
                completeMainLoader();
            }
        },
    };

    if (opts && opts.url) {
        options.url = opts.url;
    }

    return options;
}

export function beforeMainLoader() {
    $('#main-loader')
        .css({display: 'flex'})
        .html(`<sinclair-spinner></sinclair-spinner>`);
}

export function completeHandler() {}

export function showTopLoader() {
    $('.sda-top-loader').show();
}

export function hideTopLoader() {
    $('.sda-top-loader').hide();
}

export function completeMainLoader() {
    $('#main-loader')
        .hide()
        .empty();
}

export function errorHandler(model, response) {
    if (response && response.status === 403) {
        // force delete cache when the user gets a 403 Unauthorized.
        window.localStorage.clear();
        window.location = '/signout';
    }
}

export function parseLegacyReturn(data) {
    if (isNil(data)) {
        return Promise.reject('No data to parse');
    } else {
        return new Promise(function(resolve, reject) {
            if (data.hasOwnProperty('success')) {
                if (data.success) {
                    return resolve(data.data);
                } else {
                    return reject(data);
                }
            } else {
                if (data.hasOwnProperty('data')) {
                    return resolve(data.data);
                } else {
                    return resolve(data);
                }
            }
        });
    }
}

export const withMainLoader = Object.freeze({
    beforeSend: beforeMainLoader,
    complete: completeMainLoader,
});

export const withTopLoader = Object.freeze({
    beforeSend: showTopLoader,
    complete: hideTopLoader,
});
